import api from '@/api';
import ApiKey from '@/models/apiKey';

export async function list(plantId: number): Promise<Array<ApiKey>> {
  const { data } = await api.get(`plants/${plantId}/api-keys`);
  return data;
}

export async function create(plantId: number): Promise<ApiKey> {
  const { data } = await api.post(`plants/${plantId}/api-keys`);
  return data;
}

export async function remove(key: string): Promise<void> {
  await api.delete(`api-keys/${key}`);
}
